module.exports = __webpack_public_path__ + "static/img/PVC_Img1.09293e69.jpg";